import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";

// 클릭리스 명칭
import { ReactComponent as Img } from "../../images/logo_clickless.svg";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  return <Box component={Img} sx={{ width: 140, height: 50, ...sx }} />;
}
